<template>
  <div class="edit-video-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="公告类型:" prop="type" v-if="this.title === '新增公告'">
          <el-select v-model="params.type" size="small">
            <el-option v-for="item in typeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="params.title" size="small"></el-input>
        </el-form-item>
        <el-form-item label="图片:" prop="cover" v-if="params.type===3">
          <base-upload :cover="params.cover" :action="action" @successCallback="handleAvatarSuccess" :wSize="280" :hSize="350" :width="'140px'" :height="'170px'"></base-upload>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="6" v-model="params.content" size="small"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="href">
          <el-input v-model="params.href" size="small" type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-switch v-model="params.active">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
// import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      typeList: [
        { label: '系统公告弹窗', value: 0 },
        
        //  { label: '通知信息弹窗', value: 1},
        { label: 'VIP升级公告弹窗', value: 3 }
      ],
      // 图片上传地址
      // action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      params: {
        title: "",
        cover: "",
        content: '',
        href: '',
        type: '',
        active: false
      },
      rules: {
        type: [{ required: true, message: '请选择公告类型', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        //cover: [{ required: true, message: '请上传图片', trigger: 'blur' },],
        //href: [{ required: true, message: '请输入链接', trigger: 'blur' },],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' },],
      }
    }
  },
  methods: {
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.cover = res.data.coverImg
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        title: "",
        cover: "",
        content: '',
        href: '',
        active: false,
        type: ''
      }
      this.$refs.form.resetFields()
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑公告') {
            this.editAnnou()
          } else {
            this.addAnnou()
          }
        } else {
          return false;
        }
      });
    },
    editAnnou() {
      let params = Object.assign(this.params, { id: this.id });
      API.editAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    addAnnou() {
      let params = this.params;
      API.addAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('新增失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑公告'
        this.params.title = data.title
        this.params.cover = data.cover
        this.params.content = data.content
        this.params.href = data.href
        this.params.active = data.active
        this.params.type = data.type
        this.id = data.id
      } else {
        this.title = '新增公告'
      }
    }
  }
}
</script>

<style lang="scss" >
</style>
